import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiMessageResponse } from '../models/api.models';
import { AppNotification, NotificationsResponse } from '../models/notification.models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private readonly api = inject(ApiService);

  list(page = 1): Observable<NotificationsResponse> {
    return this.api.get<NotificationsResponse>('/notifications', { page });
  }

  markRead(id: string): Observable<AppNotification> {
    return this.api.post<AppNotification>(`/notifications/${id}/read`);
  }

  markAllRead(): Observable<ApiMessageResponse> {
    return this.api.post<ApiMessageResponse>('/notifications/read-all');
  }
}
